import { all } from 'redux-saga/effects';

import bookmarks from './bookmarks/saga';
import config from './config/saga';
import details from './details/saga';
import epg from './epg/saga';
import programs from './programs/saga';
import railsBuilder from './railsBuilder/saga';
import recordings from './recordings/saga';
import user from './user/saga';

export default function* () {
    yield all([
        ...config,
        ...user,
        ...railsBuilder,
        ...programs,
        ...epg,
        ...details,
        ...bookmarks,
        ...recordings,
    ]);
}
